import { render, staticRenderFns } from "./DashCase.vue?vue&type=template&id=09944ea2&scoped=true&"
import script from "./DashCase.vue?vue&type=script&lang=js&"
export * from "./DashCase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09944ea2",
  null
  
)

export default component.exports